export default __webpack_public_path__ + "static/media/next.846e8544.png";